'use strict';

var base = require('./../common/analyticsBase');

var cntrlIsPressed = false;
$(document).keydown(function(event) {
    if (event.which == '17') {
        cntrlIsPressed = true;
    }
});

$(document).keyup(function() {
    cntrlIsPressed = false;
});

$(document).on('analytics:dataLayerPushObj', function(_, object) {
    base.dataLayerPush(object);
});

$(document).on('analytics:promoViewAutoSlider', function(_, promo, position) {
    base.checkPromo($(promo), window.pageYOffset, position);
});

$('body').on('analytics:changeTemplateProduct', function(e) {
    base.checkCollisionNotImpressed($('.js-analytics-impressions-block-load'));
});

$('body').on('analytics:openMenuSection', function(e) {
    base.checkCollisionNotImpressed($('.js-analytics-impression-header'));
});

$(document).on('afterChange', '.slick-slider', function(e) {
    base.checkCollisionNotImpressed($(this).parents('.js-analytics-impressions-relatives-load'));
});

$('body').on('analytics:pushAddToCart', function(e, product) {
    base.pushAddToCart(product);
});

$('body').on('analytics:pushRemoveFromCart', function(e, data) {
    base.pushRemoveFromCart(data.selector, data.quantity, data.from, data.oncomplete);
});

$('body').on('analytics:pushChangeQuantity', function(e, data) {
    base.pushChangeQuantity(data.selector, data.type, data.from);
});

$('body').on('analytics:pushgeolocationbanner', function(e, data) {
    base.dataLayerPush({
        event: 'custom_event',
        eventCategory: data.eventCategory,
        eventAction: data.eventAction,
        eventLabel: data.eventLabel
    });
});

$(document).on('analytics:video', function(e, data) {
    base.dataLayerPush({
        event: 'video',
        eventCategory: 'Video',
        eventAction: data.eventAction,
        eventLabel: data.eventLabel
    });
});

$('body').on('analytics:clickpayment', function(e, data) {
    var paymentType = $(data).attr('id');
    if (paymentType === 'rb_scheme' || paymentType.indexOf('rb_storedCard') > -1) {
        paymentType = 'radio-CREDIT_CARD';
    }

    base.dataLayerPush({
        event: 'checkoutOption',
        ecommerce: {
            checkout_option: {
                actionField: { step: 4, option: paymentType }
            }
        }
    });
});

$('body').on('analytics:clickpaymentnewcheckout', function(e, data) {
    var paymentType = $(data).attr('id');
    if (paymentType === 'rb_scheme' || paymentType.indexOf('rb_storedCard') > -1) {
        paymentType = 'radio-CREDIT_CARD';
    }

    base.dataLayerPush({
        event: 'checkoutOption',
        ecommerce: {
            checkout_option: {
                actionField: { step: 5, option: paymentType }
            }
        }
    });
});

$(document).on('shop-the-image:modal-open', function(e){
    base.checkCollisionNotImpressed($('.js-analytics-impressions-relatives-load'));
});

$('body').on('wishlist:productAnalytics', function(e) {
    var prodAnalytics = $('.js-analytics-wishlist');
    base.loadAnalyticsProduct(prodAnalytics).done(function() {
        base.checkCollisionNotImpressed($('.js-analytics-impressions-block-load'));
    });
});

$('body').on('suggestion:productAnalytics', function(e, data) {
    var container = $(data && data.container ? data.container : (window.isMobile || window.isTabletPortrait ? '.cc-only-mobile .js-analytics-impression-search' : '.cc-no-mobile .js-analytics-impression-search'));
    var prodAnalytics = container.find('.js-analytics-suggestion');
    base.loadAnalyticsProduct(prodAnalytics).done(function() {
        base.checkCollisionNotImpressed(container);
    });
});

$(document).on('analytics:newsletter', function(e, data) {
    var obj = {
        event: 'newsletter',
        eventCategory: 'Newsletter',
        eventAction: data.eventAction,
        eventLabel: data.eventLabel
    }

    if (data.other) {
        obj.interestList = data.other;
    }

    base.dataLayerPush(obj);
});

$('body').on('analytics:pushpagechange', base.analyticsPushPage);

$('body').on('analytics:pushuserdatachange', base.analyticsPushUserData);

$('body').on('analytics:pushCheckoutStep', function(e, data) {
    var products = base.initializeCheckoutProducts(data.selector);
    base.pushCheckoutObject(products, data.step, data.step_type);
});

$('body').on('analytics:pushPurchase', function(e, data) {
    var products = base.initializeCheckoutProducts(data.selector);
    base.pushPurchaseObject(products);
});

// ------------------------------------------------- page events -------------------------------------------------
$(document).on('click', '.js-promo-click', function(e) {
    var $promo = $(this).closest('.js-promo');
    base.analyticsPushPromoClick(e.currentTarget, $promo);
});

$(document).on('click', '.js-analytics-product-swatch', function(e) {
    e.preventDefault();
    base.analyticsPushChangeVariation(e.currentTarget);
});

var alreadySend = false;
$(document).on('mousedown', '.js-analytics-click-product', function(e) {
    // e.preventDefault();
    if ((!alreadySend && window.isMobile) || !window.isMobile) {
        var el = $(this);
        if (!el.attr('data-pid')) {
            el = $(this).siblings('.js-analytics-click-product');
        }
        var pos = 0;
        var inToRemove = 0;
        var previousElement = '';
        $('.js-analytics-click-product').each(function (index, element) {
            if (!$(element).attr('data-pid')) {
                inToRemove++;
            }
            if ($(element).attr('data-pid') && previousElement !== '' && $(element).attr('data-pid') === $(previousElement).attr('data-pid')) {
                inToRemove++;
            } else if ($(element).attr('data-pid')) {
                previousElement = element;
            }
            if (el.attr('data-pid') === $(element).attr('data-pid')) {
                pos = index - inToRemove;
                return false;
            }
        });
        pos++;
        var pid = $(this).attr('data-pid') || $(this).attr('data-id');

        if (!pid) {
            pid = $(e.currentTarget).closest('.product').attr('data-pid');
        }

        var checkAnalyticsInit = setInterval(function() {
            var product = $('.js-analytics-impressions-product-initialized.js-analytics-click-product-info-' + pid);
            if (product.length > 1) {
                let $parent = $(this).closest('.product').find('.js-analytics-click-product-info-' + pid);
                if ($parent.length) product = $parent;
                if (product.closest('.slick-slide.slick-cloned').length) {
                    product = product.closest('.slick-track').find('.slick-slide:not(.slick-cloned) .js-analytics-click-product-info-' + pid);
                }
            }

            if (product.length) {
                clearInterval(checkAnalyticsInit);
                base.analyticsPushProductClick(product);
            }
        }, 100);

        if (window.isMobile && !cntrlIsPressed) {
            alreadySend = true;
        }
    }
});

$(document).on('click', '.js-add-size-product-analytics', function(e) {
    var $analytics = $(this).parents('.product').find('.new-analytics');
    var sizeCode = $(this).attr('data-value');

    if (e.originalEvent !== undefined) { // check if event is triggered or is a click of the user
        var masterPid = $analytics.attr('data-pid');
        var color = $analytics.attr('data-color');
        var sku = masterPid + color;    // pid concatenation tiles
        
        base.dataLayerPush({
            event: 'custom_event',
            eventCategory: 'Size Selector',
            eventAction: 'size select',
            eventLabel: `${sku} - ${sizeCode}`,
            buttonType: 'Quick Cart Add',
            accessType: 'tile'
        });
        $('#size-overlay').removeData('analyticsowner');
    }

    // set current size
    $analytics.attr({
        'data-size': sizeCode
    });
});

$(document).on('click', '.js-add-size-product-page-analytics', function(e) {
    var $analytics = $('.product-detail .new-analytics');
    var masterPid = $analytics.attr('data-pid');
    var color = $analytics.attr('data-color');
    var sizeCode = $(this).data('attr-value');

    if (e.originalEvent !== undefined) {
        var analyticsOwn = $('#size-overlay').data('analyticsowner') || $('#size-modal-sticky').data('analyticsowner');
        var accessType = $('#size-overlay').data('accessType') || $('#size-modal-sticky').data('accessType');
        var sku = masterPid + color;    // pid concatenation tiles

        base.dataLayerPush({
            event: 'custom_event',
            eventCategory: 'Size Selector',
            eventAction: 'size select',
            eventLabel: sku + ' - ' + sizeCode,
            buttonType: analyticsOwn,
            accessType: accessType
        });
        $('#size-overlay').removeData('analyticsowner');
        $('#size-modal-sticky').removeData('accessType');
    }

    // set current size
    $analytics.attr({
        'data-size': sizeCode
    });
});

$(document).on('click', '.js-add-color-variation-analytics', function(e) {
    var pid = $(this).data('pid');
    var color = $(this).data('value');
    var product = $('.js-analytics-click-product-info-' + pid);
    // product.attr('data-color', color);
    product.data('color', color)
});

$(document).on('click', '.js-contact-open-analytics', function(e) {
    var type = $(this).data('type');
    base.dataLayerPush({
        event: 'contactUs',
        eventCategory: 'Contact Us - Other',
        eventAction: ' submit_ok',
        eventLabel: type
    });
});

$(document).on('click', '.js-contact-checkout-analytics', function(e) {
    var type = $(this).data('type');
    base.dataLayerPush({
        event: 'custom_event',
        eventCategory: 'checkout',
        eventAction: ' help request',
        eventLabel: type
    });
});

$(document).on('click', '.js-analytics-subcategory-mypage', function(e) {
    var subcategory = $(this).data('subcategory');
    var pushObject = {
        pagesubCategory: subcategory
    };

    if (subcategory === 'MyRequests') {
        pushObject.pageDetail = $('.js-myRequest-analyticsDetail').val();
    }

    var advisorID = $('#advisorID').val();
    if (advisorID) {
        pushObject.client_advisor_id = advisorID;
    }
    base.analyticsPushPage(e, pushObject);
});

$(document).on('click', '.cc-cta', function(e) {
    var isExlusiveServiceApponintment = $('.pagesubCategory').text() === 'exclusive-service-appointment';
    if ($(this).closest('.js-promo').length > 0) {
        if ($(this).closest('.js-promo').hasClass('js-book-appointment')) {
            base.dataLayerPush({
                event: 'custom_event',
                eventCategory: 'exclusive-service',
                eventAction: isExlusiveServiceApponintment ? 'appointment-page' : 'service-page',
                eventLabel: 'boutique-appointment'
            });
        }
    }

    if ($(this).closest('.js-promo').length > 0) {
        if ($(this).closest('.js-promo').hasClass('js-style-advisor')) {
            base.dataLayerPush({
                event: 'custom_event',
                eventCategory: 'exclusive-service',
                eventAction: isExlusiveServiceApponintment ? 'appointment-page' : 'service-page',
                eventLabel: 'virtual-appointment'
            });
        }
    }
});

$(document).on('click', '.js-exclusive-service-header', function(e) {
    base.dataLayerPush({
        event: 'custom_event',
        eventCategory: 'exclusive-service',
        eventAction: 'header',
        eventLabel: document.location.href
    });
});

$(document).on('click', '.js-exclusive-service-menu', function(e) {
    base.dataLayerPush({
        event: 'custom_event',
        eventCategory: 'exclusive-service',
        eventAction: 'menu',
        eventLabel: document.location.href
    });
});

$(document).on('click', '.cc-button', function(e) {
    var isExclusiveServiceBanner = $(this).closest('.js-promo') ? $(this).closest('.js-promo').hasClass('js-exclusive-service-banner') : false;

    if (isExclusiveServiceBanner) {
        base.dataLayerPush({
            event: 'custom_event',
            eventCategory: 'exclusive-service',
            eventAction: 'banner',
            eventLabel: document.location.href
        });
    }
});

$(document).on('click', '.js-exclusive-service-footer', function(e) {
    base.dataLayerPush({
        event: 'custom_event',
        eventCategory: 'exclusive-service',
        eventAction: 'footer',
        eventLabel: document.location.href
    });
});

// ------------------------------------------------- page events -------------------------------------------------
$(window).on('load', base.analyticsCheckImpressionAndPromo);

$(window).scroll(base.analyticsCheckImpressionAndPromo);

// ------------------------------------------------- module 31 Shop The Image -------------------------------------------------
$('.cc-pd-shop-the-image .cc-pd__modal').on('scroll', base.analyticsCheckImpressionAndPromo);
